import { CDS_ZINDEX } from '@revenuemarket/cds';
import { ResponseStatus } from '@revenuemarket/http';
import { Toast } from '@revenuemarket/ui';
import { Button, Tooltip, Modal } from 'antd';
import { useRouter } from 'next/router';

import { useCancelMappingForTaxInvoice } from '~hooks/queries/mapping/query';
import { useDemoAwareCompanyId } from '~hooks/useDemoAwareCompanyId';
import { TaxInvoiceType } from '~models/tax-invoice';

interface Props {
  targetIds?: string[];
  type: TaxInvoiceType;
  onMappingSuccess?: () => void;
}

const SettlementMappingCancelButton: React.FC<Props> = ({
  targetIds = [],
  type,
  onMappingSuccess,
}) => {
  const [modal, contextHolder] = Modal.useModal();
  const { companyId } = useDemoAwareCompanyId();
  const router = useRouter();
  const urlPathFromSettlement = router.asPath.includes('settlement');
  const zIndexBase = CDS_ZINDEX.FLOATING_BUTTON + (urlPathFromSettlement ? 1 : 10000);
  const { mutateAsync: cancelMapping, isLoading } = useCancelMappingForTaxInvoice();
  const disabled = targetIds?.length === 0;

  const onMappingCancel = async () => {
    const response = await cancelMapping({
      companyId,
      request: {
        taxInvoiceKeys: targetIds.map((id) => ({
          taxInvoiceId: id,
          taxInvoiceType: type,
        })),
      },
    });
    if (response.Status === ResponseStatus.SUCCESS) {
      Toast.success('연결이 해제됐습니다');
      onMappingSuccess?.();
    } else {
      Toast.error('정산 내역 연결 해제에 실패했습니다.');
    }
  };

  return (
    <Tooltip zIndex={CDS_ZINDEX.POP_UP + 1} title={disabled ? '연결된 거래내역이 없습니다.' : ''}>
      {contextHolder}
      <Button
        type="link"
        style={{
          color: disabled ? '#d9d9d9' : '',
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
        onClick={() => {
          if (disabled) return;
          modal.confirm({
            icon: null,
            zIndex: zIndexBase,
            title: `세금계산서 ${targetIds?.length}건의 정산 내역 연결을 해제할까요?`,
            content: '정산 내역이 없는 세금계산서는 제외됐습니다.',
            cancelText: '닫기',
            okText: '정산 내역 연결 해제하기',
            okButtonProps: { loading: isLoading },
            onOk: onMappingCancel,
          });
        }}
      >
        정산 내역 연결 해제
      </Button>
    </Tooltip>
  );
};

export default SettlementMappingCancelButton;
